import throttle from 'lodash/throttle';

export default class Navbar {
  constructor({selector, offset, fixedClass} = {}) {
    this.navbar = document.querySelector(selector);
    this.offset = offset;
    this.fixedClass = fixedClass;

    this.toggleView = this.toggleView.bind(this);
    this.init();
  }

  init() {
    if (!this.navbar) return;
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener('scroll', throttle(this.toggleView, 100));
  }

  toggleView() {
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    this.navbar.classList.toggle(this.fixedClass, scrollTop > this.offset);
  }
};